import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  hasErrors: false,
  type: "",
  messages: "",
  data:{},
  error: {},
};
// A slice for auth with our success or failure reducers
const buildingprofileSlice = createSlice({
  name: "BuildingProfile",
  initialState,
  reducers: {
    getFailure: (state, { payload }) => ({
      ...state,
      hasErrors: true,
      type: payload.type,
      messages: payload.messages,
      error: payload,
    }),
    getSuccess: (state, { payload }) => ({
     ...state,
      hasErrors: false,
      type: payload.type,
      messages: payload.messages,
      data: payload.guruDto,
    }),
    resetState: (state) => ({
      ...state,
      hasErrors: false,
      type: "",
      messages: "",
      error: {},
      data:{}
    }),
  },
});

// eslint-disable-next-line max-len
export const {
  getFailure,
  getSuccess,
  resetState,
} = buildingprofileSlice.actions;

// A selector
export const buildingprofileSelector = (state) => state.buildingprofile;

// The reducer
export default buildingprofileSlice.reducer;
